import type { ModalState } from './types';

const initialState: ModalState = {
  queue: [],
};

export default initialState;
